import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { putCart } from '../../actions/app/cart.actions'
import { switchPriceView } from '../../actions/app/priceView.actions'
import availablePriceViewsSelector from '../../selectors/availablePriceViewsSelector'

const priceViewMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(switchPriceView, action)) {
        const state = getState()
        const availablePriceViews = availablePriceViewsSelector(state)
        const newPriceView = availablePriceViews.filter(el => el.toString() === action.payload)

        dispatch(putCart(newPriceView[0]))
    }
}

export default priceViewMiddleware
